import ProduitEcranCible from "../../domain/ProduitEcranCible";

export const uppers = new ProduitEcranCible('ctup', 'Cine Target Uppers', 'Entrées Uppers', {
  'S2001': {audience: 367944, tarif: 214510},
  'S2002': {audience: 258699, tarif: 98030},
  'S2003': {audience: 334841, tarif: 126890},
  'S2004': {audience: 335839, tarif: 127270},
  'S2005': {audience: 441152, tarif: 295770},
  'S2006': {audience: 532072, tarif: 372240},
  'S2007': {audience: 590592, tarif: 447610},
  'S2008': {audience: 586711, tarif: 444670},
  'S2009': {audience: 447334, tarif: 286880},
  'S2010': {audience: 399057, tarif: 255920},
  'S2011': {audience: 358233, tarif: 187960},
  'S2012': {audience: 331574, tarif: 173980},
  'S2013': {audience: 341573, tarif: 199140},
  'S2014': {audience: 401769, tarif: 269370},
  'S2015': {audience: 378676, tarif: 253880},
  'S2016': {audience: 384496, tarif: 257790},
  'S2017': {audience: 510029, tarif: 386550},
  'S2018': {audience: 399839, tarif: 244760},
  'S2019': {audience: 318967, tarif: 167360},
  'S2020': {audience: 298845, tarif: 156800},
  'S2021': {audience: 367491, tarif: 235670},
  'S2022': {audience: 307593, tarif: 188290},
  'S2023': {audience: 356660, tarif: 207930},
  'S2024': {audience: 318499, tarif: 148550},
  'S2025': {audience: 317225, tarif: 147950},
  'S2026': {audience: 377633, tarif: 374270},
  'S2027': {audience: 503076, tarif: 381280},
  'S2028': {audience: 439271, tarif: 281700},
  'S2029': {audience: 438784, tarif: 306970},
  'S2030': {audience: 406397, tarif: 236930},
  'S2031': {audience: 384027, tarif: 223890},
  'S2032': {audience: 424991, tarif: 247770},
  'S2033': {audience: 399263, tarif: 232770},
  'S2034': {audience: 334525, tarif: 126770},
  'S2035': {audience: 320247, tarif: 130690},
  'S2036': {audience: 342408, tarif: 199620},
  'S2037': {audience: 310903, tarif: 190320},
  'S2038': {audience: 339433, tarif: 237470},
  'S2039': {audience: 362306, tarif: 253470},
  'S2040': {audience: 308812, tarif: 180040},
  'S2041': {audience: 347753, tarif: 202740},
  'S2042': {audience: 397301, tarif: 277950},
  'S2043': {audience: 456691, tarif: 346130},
  'S2044': {audience: 462909, tarif: 323850},
  'S2045': {audience: 400511, tarif: 256850},
  'S2046': {audience: 418336, tarif: 280470},
  'S2047': {audience: 384550, tarif: 257820},
  'S2048': {audience: 407209, tarif: 273010},
  'S2049': {audience: 425758, tarif: 372330},
  'S2050': {audience: 460640, tarif: 429680},
  'S2051': {audience: 647483, tarif: 622850},
  'S2052': {audience: 611141, tarif: 587890}
});

